__turbopack_export_value__({
  "arrow": "button-module-scss-module__CYkfOW__arrow",
  "baseButton": "button-module-scss-module__CYkfOW__baseButton",
  "block": "button-module-scss-module__CYkfOW__block",
  "body-logo-18": "button-module-scss-module__CYkfOW__body-logo-18",
  "body-text-12": "button-module-scss-module__CYkfOW__body-text-12",
  "body-text-14": "button-module-scss-module__CYkfOW__body-text-14",
  "body-text-16": "button-module-scss-module__CYkfOW__body-text-16",
  "body-text-18": "button-module-scss-module__CYkfOW__body-text-18",
  "body-text-20": "button-module-scss-module__CYkfOW__body-text-20",
  "body-text-24": "button-module-scss-module__CYkfOW__body-text-24",
  "body-text-24-2": "button-module-scss-module__CYkfOW__body-text-24-2",
  "body-text-heading-2": "button-module-scss-module__CYkfOW__body-text-heading-2",
  "body-text-heading-3": "button-module-scss-module__CYkfOW__body-text-heading-3",
  "body-text-medium-14": "button-module-scss-module__CYkfOW__body-text-medium-14",
  "body-text-medium-16": "button-module-scss-module__CYkfOW__body-text-medium-16",
  "body-text-medium-18": "button-module-scss-module__CYkfOW__body-text-medium-18",
  "body-text-medium2-18": "button-module-scss-module__CYkfOW__body-text-medium2-18",
  "body-text2-14": "button-module-scss-module__CYkfOW__body-text2-14",
  "body-text2-16": "button-module-scss-module__CYkfOW__body-text2-16",
  "button-primary-text": "button-module-scss-module__CYkfOW__button-primary-text",
  "button-text": "button-module-scss-module__CYkfOW__button-text",
  "button2-text": "button-module-scss-module__CYkfOW__button2-text",
  "card-shadow": "button-module-scss-module__CYkfOW__card-shadow",
  "default": "button-module-scss-module__CYkfOW__default",
  "disabled": "button-module-scss-module__CYkfOW__disabled",
  "effect-menu": "button-module-scss-module__CYkfOW__effect-menu",
  "footer": "button-module-scss-module__CYkfOW__footer",
  "header-1": "button-module-scss-module__CYkfOW__header-1",
  "icon-container": "button-module-scss-module__CYkfOW__icon-container",
  "large": "button-module-scss-module__CYkfOW__large",
  "main-container": "button-module-scss-module__CYkfOW__main-container",
  "main-footer-container": "button-module-scss-module__CYkfOW__main-footer-container",
  "main-header-container": "button-module-scss-module__CYkfOW__main-header-container",
  "medium": "button-module-scss-module__CYkfOW__medium",
  "outline": "button-module-scss-module__CYkfOW__outline",
  "outline2": "button-module-scss-module__CYkfOW__outline2",
  "primary": "button-module-scss-module__CYkfOW__primary",
  "small": "button-module-scss-module__CYkfOW__small",
  "special": "button-module-scss-module__CYkfOW__special",
  "statusClose": "button-module-scss-module__CYkfOW__statusClose",
  "statusOpen": "button-module-scss-module__CYkfOW__statusOpen",
  "statusSize": "button-module-scss-module__CYkfOW__statusSize",
  "txt-12-bold": "button-module-scss-module__CYkfOW__txt-12-bold",
  "txt-14-bold": "button-module-scss-module__CYkfOW__txt-14-bold",
  "txt-14-bold-caps": "button-module-scss-module__CYkfOW__txt-14-bold-caps",
  "txt-14-med": "button-module-scss-module__CYkfOW__txt-14-med",
  "txt-16-bold": "button-module-scss-module__CYkfOW__txt-16-bold",
  "txt-16-med": "button-module-scss-module__CYkfOW__txt-16-med",
  "txt-18-bold": "button-module-scss-module__CYkfOW__txt-18-bold",
  "txt-18-medium": "button-module-scss-module__CYkfOW__txt-18-medium",
  "txt-18-medium-24": "button-module-scss-module__CYkfOW__txt-18-medium-24",
  "txt-24-semi": "button-module-scss-module__CYkfOW__txt-24-semi",
  "violet": "button-module-scss-module__CYkfOW__violet",
  "violet2": "button-module-scss-module__CYkfOW__violet2",
});
